import { Component, Inject } from '@angular/core';
import { MatButton, MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogModule, MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { MatInput, MatLabel } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-migrate-admin-confirm',
  imports: [
    MatButtonModule,
    MatDialogModule,
    ReactiveFormsModule,
    TranslocoPipe
  ],
  templateUrl: './migrate-admin-confirm.dialog.html',
  styleUrl: './migrate-admin-confirm.dialog.scss'
})
export class MigrateAdminConfirmDialog {
  constructor(@Inject(MAT_DIALOG_DATA) public data: { title: string; description: string }, public dialogRef: MatDialogRef<MigrateAdminConfirmDialog>) {}

  close(): void {
    this.dialogRef.close();
  }
}
